import {
  CallSplitOutlined,
  ChevronLeftOutlined,
  FeedOutlined,
  InfoOutlined,
  TuneOutlined,
  VerifiedOutlined
} from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import COLORS from '../../colors';
import { Button } from '../Button';
import { SidebarNavigation } from '../SidebarNavigation';
import Section from './Section';
import { useDownloadPdf } from '../../context/PdfContext';
import { useNavigate } from 'react-router-dom';
import { useModal } from '../../context/ModalContext';

const StyledNavHeader = styled.div`
  padding: 8px 16px;
`;

const StyledNavList = styled.ul`
  margin: 0;
  padding-left: 0;
`;

const StyledActions = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
`;

const StyledButtonWrapper = styled.div`
  padding: 8px 0;
`;

const LeftSection = () => {
  const location = useLocation();
  const { closeModal, openModal } = useModal();
  const { setDownloadPdf } = useDownloadPdf();
  const navigate = useNavigate();

  const navItems = [
    {
      name: 'Campaign Details',
      icon: <InfoOutlined />,
      location: '#',
      isCompleted:
        location.pathname === '/second' ||
        location.pathname === '/third' ||
        location.pathname === '/fourth'
    },
    {
      name: 'Campaign Variables',
      icon: <TuneOutlined />,
      location: '/second',
      isCompleted:
        location.pathname === '/third' || location.pathname === '/fourth',
      isDisabled: location.pathname === '/'
    },
    {
      name: 'Weekly Budget Split',
      icon: <CallSplitOutlined />,
      location: '/third',
      isCompleted: location.pathname === '/fourth',
      isDisabled: location.pathname === '/' || location.pathname === '/second'
    },
    {
      name: 'Campaign Planner',
      icon: <FeedOutlined />,
      location: '/fourth',
      isDisabled:
        location.pathname === '/' ||
        location.pathname === '/second' ||
        location.pathname === '/third'
    }
  ];

  const handleClick = (location: string) => {
    if (location === '#') {
      showModal(
        'By navigating to step 1, you will lose any current progress. Continue?'
      );
    }
  };

  const showModal = (content: string): void => {
    openModal('ActionModal', {
      title: 'Error',
      content,
      cancelButtonText: 'Cancel',
      okButtonText: 'OK',
      modalCallback
    });
  };

  const modalCallback = () => {
    navigate('/');
    closeModal();
    navigate(0);
  };

  const handlePdf = () => {
    setDownloadPdf(true);
  };

  return (
    <Section minWidth="334px" padding="40px">
      <StyledNavHeader />
      <nav>
        <StyledNavList>
          {navItems.map((item, index) => (
            <SidebarNavigation
              key={index}
              number={index + 1}
              name={item.name}
              icon={item.icon}
              location={item.location}
              isCompleted={item.isCompleted}
              isDisabled={item.isDisabled}
              onClick={handleClick}
            />
          ))}
        </StyledNavList>
      </nav>
      {location.pathname === '/fourth' && (
        <StyledActions>
          <StyledButtonWrapper>
            <Button
              label="Download PDF"
              icon={<VerifiedOutlined />}
              backgroundColor={COLORS.PRIMARY_500}
              hoverBackgroundColor={COLORS.BUTTON_PRIMARY_HOVER}
              textColor={COLORS.PRIMARY_800}
              fullWidth
              onClick={() => handlePdf()}
            />
          </StyledButtonWrapper>
          <StyledButtonWrapper>
            <Button
              label="Back to Weekly Split"
              icon={<ChevronLeftOutlined />}
              backgroundColor="transparent"
              hoverBackgroundColor={COLORS.BUTTON_TERTIARY_HOVER}
              textColor={COLORS.PRIMARY_500}
              fullWidth
              onClick={() => navigate('/third')}
            />
          </StyledButtonWrapper>
        </StyledActions>
      )}
    </Section>
  );
};

export default LeftSection;
